import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ApiCall from '../../utils/Api';
import { CircularProgress, Alert } from '@mui/material';
import { convertDateFormat, extractTimeFromTimestamp } from '../../utils/services';

const AllFundSubscribersTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await ApiCall.SECURE_API.get('/admin/getAllFundSubscribers');
        setData(response.data.data || []);
      } catch (err) {
        setError('Failed to fetch fund subscribers');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <TableContainer component={Paper} style={{ borderRadius: 9 }}>
      <Table sx={{ minWidth: 650 }} aria-label="all fund subscribers table">
        <TableHead style={{ backgroundColor: 'Black' }}>
          <TableRow>
            <TableCell align="center" style={{ color: 'white' }}>Created At</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Name</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Email</TableCell>
            <TableCell align="center" style={{ color: 'white' }}>Wallet Address</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={row._id || idx}>
              <TableCell align="center">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <span style={{ fontWeight: 600 }}>{convertDateFormat(row.createdAt)}</span>
                  <span style={{ color: 'gray' }}>{extractTimeFromTimestamp(row.createdAt)}</span>
                </div>
              </TableCell>
              <TableCell align="center">{row.firstName} {row.lastName}</TableCell>
              <TableCell align="center">{row.email}</TableCell>
              <TableCell align="center">{row.walletAddress}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AllFundSubscribersTable;